import { APIInstance } from 'config';
import { API } from 'constants/apiEndpoints';
import { PAGINATION_TYPE, RESPONSE_TYPE } from 'models';
import { REPORT_BODY_REQUEST, REPORT_REASON_TYPE } from 'models/report';
import { REVIEW_TYPE, SITTER_TYPE } from 'models/sitter';

export const sitterApi = {
  getDetail: (id: string) => {
    return APIInstance.get<RESPONSE_TYPE<SITTER_TYPE>>(
      `${API.SITTER.DETAIL}/${id}`,
    );
  },
  getReview: (params: { user_id: string }) => {
    return APIInstance.get<RESPONSE_TYPE<REVIEW_TYPE>>(API.SITTER.REVIEWS, {
      params,
    });
  },
  report: (data: REPORT_BODY_REQUEST) => {
    return APIInstance.post(API.SITTER.REPORT, data);
  },
  getReason: () => {
    return APIInstance.get<
      RESPONSE_TYPE<PAGINATION_TYPE<REPORT_REASON_TYPE[]>>
    >(API.SITTER.REPORT_REASON);
  },
};
